<template>
  <div>
    <div class="contract">
      <Header
        v-if="!checkCreatedDateNganluong(dataAppendix)"
        :groupService="dataContract.groupService"
      ></Header>
      <HeaderNL v-else :groupService="dataContract.groupService"></HeaderNL>
      <p class="txt-center fonsize-16 txt-tranf">CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM</p>
      <p class="txt-center fonsize-16">Độc lập – Tự do – Hạnh phúc</p>
      <p class="txt-center fonsize-16">***</p>

      <p class="txt-tranf txt-center fonsize-20">
        <b>BIÊN BẢN THANH LÝ HỢP ĐỒNG</b>
      </p>
      <p class="txt-center">
        (V/v: Thanh lý Hợp đồng dịch vụ thanh toán số :
        <mark>{{ dataAppendix.code }}</mark>
        )
      </p>
      <p><i>Căn cứ Bộ luật dân sự năm 2015 và Luật thương mại 2005;</i></p>
      <p>
        <i
          >Căn cứ Hợp đồng dịch vụ thanh toán số:<mark>{{
            dataAppendix?.isNganluongContract ? dataAppendix.codeOfContract : dataContract.code
          }}</mark>
          ký ngày
          <mark v-if="dataAppendix?.isNganluongContract">
            {{ dataAppendix?.dateSignContract | formatDate }}</mark
          >
          <mark v-else>{{
            dataContract.effectiveFromDTO
              ? dataContract.effectiveFromDTO
              : dataContract.dateSign | formatDate
          }}</mark>
        </i>
      </p>
      <p><i>Căn cứ nhu cầu và khả năng của các bên,</i></p>
      <p>
        Hôm nay, ngày
        <mark v-if="dataAppendix.dateSignAppendixDTO">{{
          dataAppendix.dateSignAppendixDTO | formatDate
        }}</mark>
        <mark v-else-if="dataAppendix.dateCreatedAppendixDTO">{{
          dataAppendix.dateCreatedAppendixDTO | formatDate
        }}</mark>
        <mark v-else-if="dataContract.effectiveFromDTO">{{
          dataContract.effectiveFromDTO | formatDate
        }}</mark>
        , chúng tôi gồm:
      </p>
      <p class="fonsize-16 txt-tranf">
        <b v-if="!checkCreatedDateNganluong(dataAppendix)"
          >BÊN A: CÔNG TY CỔ PHẦN CÔNG NGHỆ VI MÔ</b
        >
        <b v-else>BÊN A: CÔNG TY CỔ PHẦN CỔNG TRUNG GIAN THANH TOÁN NGÂN LƯỢNG</b>
      </p>
      <p v-if="checkCreatedDateNganluong(dataAppendix)">
        Địa chỉ: Tầng 3, tòa nhà VTC online số 18 Đường Tam Trinh, Phường Tương Mai, Thành phố Hà
        Nội, Việt Nam.
      </p>
      <p v-else>
        Địa chỉ: Tầng 12A, tòa nhà VTC online số 18 Đường Tam Trinh, Phường Tương Mai, Thành phố Hà
        Nội, Việt Nam.
      </p>
      <div class="form form-ext">
        <p>
          Điện thoại: 024 36320986
          <span class="ml-4" v-if="!checkCreatedDateNganluong(dataAppendix)"
            >Fax: 024 36320987</span
          >
        </p>
        <p v-if="!checkCreatedDateNganluong(dataAppendix)">Tài khoản: 11001010157634</p>
        <p v-if="!checkCreatedDateNganluong(dataAppendix)">Tại: Ngân hàng Maritimebank</p>
        <p v-if="checkCreatedDateNganluong(dataAppendix)">Mã số thuế: 0106001236</p>
        <p v-else>Mã số thuế: 0106393463</p>
        <p>
          Người đại diện:
          <b
            v-if="
              dataAppendix?.dateSignAppendixDTO ||
              dataAppendix?.dateCreatedAppendixDTO ||
              dataContract?.effectiveFromDTO
                ? (dataAppendix?.dateSignAppendixDTO ||
                    dataAppendix?.dateCreatedAppendixDTO ||
                    dataContract?.effectiveFromDTO) < new Date('2026-01-07').getTime()
                : new Date() < new Date('2026-01-07')
            "
            >ĐỖ CÔNG DIỄN</b
          >
          <b v-else>Ông NGUYỄN TIẾN LƯỢNG</b>
          <span class="ml-4"
            >Chức vụ: <b v-if="!checkCreatedDateNganluong(dataAppendix)">Tổng Giám Đốc</b
            ><b v-else>Phó Tổng Giám đốc kiêm Giám đốc BU Chuyển đổi số</b></span
          >
        </p>
        <p v-if="checkCreatedDateNganluong(dataAppendix)">
          Giấy ủy quyền số: 1302/2026/GUQ/NGANLUONG ngày 13/02/2026
        </p>
      </div>
      <p class="fonsize-16 txt-tranf flex">
        <span> <b>BÊN B:</b></span>
        <mark
          ><b>{{ customerInfo.merchantName }}</b></mark
        >
      </p>
      <p><b>(sau đây được gọi là “BÊN B”)</b></p>
      <p>
        <span>Địa chỉ trụ sở: </span>
        <mark
          ><b>
            {{ customerInfo ? customerInfo.address : 'Không có' }},
            {{ customerInfo ? customerInfo.district : 'Không có' }},
            {{ customerInfo ? customerInfo.city : 'Không có' }}
          </b></mark
        >
      </p>
      <p>
        Website: <mark>{{ customerInfo ? customerInfo.website : '' }}</mark>
      </p>
      <p>
        Điện thoại: <mark>{{ customerInfo ? customerInfo.mobile : '' }}</mark>
      </p>
      <p>
        Tài khoản:<mark> {{ customerInfo.accountNo }}</mark>
      </p>
      <p>
        Tại: <mark>{{ customerInfo ? customerInfo.bankName : '' }}</mark>
      </p>
      <p>
        <span>Mã số thuế:</span>
        <mark
          ><b>{{ customerInfo ? customerInfo.businessRegistrationNumber : '' }}</b></mark
        >
      </p>
      <p>
        <span>Người đại diện:</span>
        <mark
          ><b> {{ customerInfo ? customerInfo.customerName : '' }}</b>
        </mark>
        <span>Chức vụ:</span>
        <mark>{{ customerInfo ? customerInfo.position : '' }}</mark>
      </p>

      <p>&nbsp;</p>
      <p>
        Hai bên cùng thống nhất thanh lý hợp đồng Dịch vụ thanh toán số
        <mark>{{
          dataAppendix?.isNganluongContract ? dataAppendix.codeOfContract : dataContract.code
        }}</mark>
        ngày
        <mark v-if="dataAppendix.dateSignAppendixDTO">{{
          dataAppendix.dateSignAppendixDTO | formatDate
        }}</mark>
        <mark v-else-if="dataAppendix.dateCreatedAppendixDTO">{{
          dataAppendix.dateCreatedAppendixDTO | formatDate
        }}</mark>
        (1) và các phụ lục đi kèm với những nội dung như sau:
      </p>
      <ol style="padding: 10px 0 0 10px !important">
        <li>
          <h1 style="font-size: 16px"><b>Nội dung thực hiện</b></h1>
          <ul class="form-style-base" style="counter-reset: none">
            <li>
              Bằng Biên bản này Hai Bên cùng thống nhất chấm dứt hiệu lực và tiến hành thanh lý Hợp
              đồng dịch vụ thanh toán số
              <mark>{{
                dataAppendix?.isNganluongContract ? dataAppendix.codeOfContract : dataContract.code
              }}</mark>
              ký ngày
              <mark v-if="dataAppendix?.isNganluongContract">
                {{ dataAppendix?.dateSignContract | formatDate }}</mark
              >
              <mark v-else>{{
                dataContract.effectiveFromDTO
                  ? dataContract.effectiveFromDTO
                  : dataContract.dateSign | formatDate
              }}</mark
              >và các phụ lục hợp đồng đi kèm;.
            </li>
            <li>
              Với các thiết bị thanh toán Bên A đã cung cấp cho Bên B theo Hợp đồng dịch vụ thanh
              toán số
              <mark>{{
                dataAppendix?.isNganluongContract ? dataAppendix.codeOfContract : dataContract.code
              }}</mark>
              ký ngày
              <mark v-if="dataAppendix?.isNganluongContract">
                {{ dataAppendix?.dateSignContract | formatDate }}</mark
              >
              <mark v-else>{{
                dataContract.effectiveFromDTO
                  ? dataContract.effectiveFromDTO
                  : dataContract.dateSign | formatDate
              }}</mark
              >và các phụ lục hợp đồng đi kèm, hai Bên đồng ý thực hiện các tác vụ sau:
              <div class="w-full">
                <br />
                <i class="text-center w-full" style="text-align: center"
                  >(Vui lòng đánh dấu X vào phương án xử lý tương ứng được thống nhất bởi hai
                  Bên)</i
                >
                <br />
                <table
                  style="
                    width: 100%;
                    border-collapse: collapse;
                    border: 1px solid black;
                    margin-top: 10px;
                  "
                >
                  <tr>
                    <td
                      style="
                        border: 1px solid black;
                        text-align: center;
                        vertical-align: middle;
                        width: 60px;
                        padding: 10px;
                      "
                    >
                      <div
                        style="
                          width: 20px;
                          height: 20px;
                          border: 2px solid black;
                          display: flex;
                          align-items: center;
                          justify-content: center;
                        "
                      >
                        <span v-if="listMcOwned.length > 0" style="font-weight: bold">X</span>
                      </div>
                    </td>
                    <td style="border: 1px solid black; padding: 5px; text-align: justify">
                      Bên A khóa các tài khoản hiện có của Bên B trên hệ thống thanh toán của Bên A,
                      các thiết bị thanh toán sẽ thuộc quyền sở hữu của Bên B.
                      <span style="color: red"
                        >Danh sách các thiết bị sẽ thuộc quyền sở hữu của Bên B được liệt kê tại
                        khoản d của Điều 1 này.</span
                      >
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="
                        border: 1px solid black;
                        text-align: center;
                        vertical-align: middle;
                        padding: 10px;
                      "
                    >
                      <div
                        style="
                          width: 20px;
                          height: 20px;
                          border: 2px solid black;
                          display: flex;
                          align-items: center;
                          justify-content: center;
                        "
                      >
                        <span v-if="listReturnNextPay.length > 0" style="font-weight: bold">X</span>
                      </div>
                    </td>
                    <td style="border: 1px solid black; padding: 5px; text-align: justify">
                      Bên A khóa các tài khoản hiện có của Bên B trên hệ thống thanh toán của Bên A
                      và Bên B bàn giao lại các thiết bị Bên A đã cung cấp cho Bên B. Danh sách các
                      thiết bị Bên B bàn giao lại cho Bên A được liệt kê tại khoản c của Điều 1 này.
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="
                        border: 1px solid black;
                        text-align: center;
                        vertical-align: middle;
                        padding: 10px;
                      "
                    >
                      <div
                        style="
                          width: 20px;
                          height: 20px;
                          border: 2px solid black;
                          display: flex;
                          align-items: center;
                          justify-content: center;
                        "
                      >
                        <span v-if="listOther.length > 0" style="font-weight: bold">X</span>
                      </div>
                    </td>
                    <td style="border: 1px solid black; padding: 5px; text-align: justify">
                      Khác (vui lòng ghi chi tiết): {{ noteText }}
                      <br />
                      ....................................................................................................................................................................
                    </td>
                  </tr>
                </table>
                <br />
              </div>
            </li>
            <li>
              Danh sách các thiết bị mà Bên B bàn giao lại cho Bên A, như sau:

              <div v-if="listReturnNextPay.length > 0">
                <div class="table-responsive">
                  <table class="table">
                    <thead>
                      <tr class="bg-head">
                        <th align="center">STT</th>
                        <th align="center">Loại thiết bị(2)</th>
                        <th align="center">Đơn vị</th>
                        <th align="center">Số lượng</th>
                        <th align="center">Serial thiết bị(3)</th>
                        <th align="center">Tình trạng sử dụng(4)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in listReturnNextPay" :key="index">
                        <td align="center">{{ index + 1 }}</td>
                        <td>{{ item.device.name }}</td>
                        <td>Thiết bị</td>
                        <td>{{ item.device.quantity }}</td>
                        <td>{{ item.device.serialNumber }}</td>
                        <td>{{ item.status }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </li>
            <li>
              Danh sách các thiết bị sẽ thuộc quyền sở hữu của Bên B như sau:
              <div v-if="listMcOwned.length > 0">
                <div class="table-responsive">
                  <table class="table">
                    <thead>
                      <tr class="bg-head">
                        <th align="center">STT</th>
                        <th align="center">Loại thiết bị(2)</th>
                        <th align="center">Đơn vị</th>
                        <th align="center">Số lượng</th>
                        <th align="center">Serial thiết bị(3)</th>
                        <th align="center">Tình trạng sử dụng(4)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in listMcOwned" :key="index">
                        <td align="center">{{ index + 1 }}</td>
                        <td>{{ item.device.name }}</td>
                        <td>Thiết bị</td>
                        <td>{{ item.device.quantity }}</td>
                        <td>{{ item.device.serialNumber }}</td>
                        <td>{{ item.status }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </li>
          </ul>
        </li>
        <li>
          <h1><b>Cam đoan của các Bên </b></h1>
          <ul class="form-style-base">
            <li>
              Việc thanh lý Hợp đồng nói trên là hoàn toàn tự nguyện, dứt khoát, không bị ép buộc và
              không kèm theo bất cứ điều kiện nào, không nhằm trốn tránh bất kỳ một nghĩa vụ nào;
            </li>
            <li>
              Việc thanh lý Hợp đồng dịch vụ thanh toán số :<mark>{{
                dataAppendix?.isNganluongContract ? dataAppendix.codeOfContract : dataContract.code
              }}</mark>
              ký ngày
              <mark v-if="dataAppendix?.isNganluongContract">
                {{ dataAppendix?.dateSignContract | formatDate }}</mark
              >
              <mark v-else>{{
                dataContract.effectiveFromDTO
                  ? dataContract.effectiveFromDTO
                  : dataContract.dateSign | formatDate
              }}</mark>
              (5) và các phụ lục hợp đồng đi kèm, không làm chấm dứt các quyền lợi, nghĩa vụ và
              trách nhiệm của các Bên phát sinh trước thời điểm Thanh lý Hợp đồng;
            </li>
            <li>
              Các bên đã đọc và đồng ý với nội dung Biên bản thanh lý Hợp đồng này, đồng thời ký
              tên, điểm chỉ, đóng dấu vào Biên bản này làm bằng chứng;
            </li>
            <li>
              Văn bản này được lập thành 02 (hai) bản, bằng tiếng Việt có nội dung và giá trị pháp
              lý như nhau, mỗi bên giữ 01 (một) bản để cùng thi hành.
            </li>
          </ul>
        </li>
      </ol>
      <Footer
        v-if="!checkCreatedDateNganluong(dataAppendix)"
        :dataContract="dataContract"
        :dataAppendix="dataAppendix"
        :isAppendix="true"
      ></Footer>
      <FooterNL
        v-else
        :dataContract="dataContract"
        :dataAppendix="dataAppendix"
        :isAppendix="true"
      ></FooterNL>
      <ul>
        <p>
          <b>
            <i>
              <u> Ghi chú: </u>
            </i>
          </b>
        </p>
        <p>
          (1) Số Hợp đồng dịch vụ thanh toán/ Hợp đồng hợp tác chấp nhận thanh toán đã ký giữa Bên B
          và Công ty Cổ phần Công nghệ Vi mô
        </p>
        <p>(2) Loại thiết bị: mPOS/ SmartPOS/ Mini SmartPOS/ SmartPOS Pro/ S85/ tài sản khác</p>
        <p>(3) Điền serial thiết bị bàn giao</p>
        <p>(4) Đánh giá tình trạng sử dụng: Tốt/ bình thường/ không sử dụng được</p>
        <p>
          (5) Số Hợp đồng dịch vụ thanh toán/ Hợp đồng hợp tác chấp nhận thanh toán đã ký giữa Bên B
          và Công ty Cổ phần Công nghệ Vi mô
        </p>
      </ul>
    </div>
  </div>
</template>

<script>
  import Header from '../block/header.vue'
  import Footer from '../block/footer.vue'
  import HeaderNL from '../block/headerNL.vue'
  import FooterNL from '../block/footerNL.vue'
  export default {
    props: ['dataContract', 'appendix'],
    components: {
      Header,
      Footer,
      HeaderNL,
      FooterNL,
    },
    data() {
      return {}
    },
    computed: {
      customerInfo() {
        return this.dataContract.customerInfoRes ?? this.dataContract.customerInfoCommon ?? {}
      },
      dataAppendix() {
        return this.appendix
      },
      listReturnNextPay() {
        if (
          !this.dataAppendix.appendixLiquidDate ||
          !this.dataAppendix.appendixLiquidDate.dataLiquidDates
        )
          return []
        return this.dataAppendix.appendixLiquidDate.dataLiquidDates.filter(
          e => e.liqOwnership === 'RETURNED_NEXTPAY'
        )
      },
      listMcOwned() {
        if (
          !this.dataAppendix.appendixLiquidDate ||
          !this.dataAppendix.appendixLiquidDate.dataLiquidDates
        )
          return []
        return this.dataAppendix.appendixLiquidDate.dataLiquidDates.filter(
          e => e.liqOwnership === 'MC_OWNED'
        )
      },
      listOther() {
        if (
          !this.dataAppendix.appendixLiquidDate ||
          !this.dataAppendix.appendixLiquidDate.dataLiquidDates
        )
          return []
        return this.dataAppendix.appendixLiquidDate.dataLiquidDates.filter(
          e => e.liqOwnership === 'OTHER'
        )
      },
      noteText() {
        if (!this.listOther || this.listOther.length === 0) return ''
        const serials = this.listOther.map(e => e.device.serialNumber).join(', ')
        const note = this.dataAppendix.appendixLiquidDate.noteOther || ''
        return `${serials}, ${note}`
      },
    },
  }
</script>

<style scoped src="@/assets/css/style-review.css"></style>
